'use client';

import { getConsentedEmails } from '@/app/actions/adminActions';
import { useState, useEffect, useMemo } from 'react';
import { Copy, Check, Search } from 'lucide-react';

export default function ConsentedEmails() {
  const [emails, setEmails] = useState<{ email: string; full_name: string }[]>(
    []
  );
  const [copiedEmail, setCopiedEmail] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    const fetchEmails = async () => {
      const data = await getConsentedEmails();
      console.log(data);
      setEmails(data);
    };
    fetchEmails();
  }, []);

  const copyToClipboard = (email: string) => {
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setTimeout(() => setCopiedEmail(null), 2000); // Reset after 2 seconds
  };

  const filteredEmails = useMemo(() => {
    if (!searchTerm) return emails;
    return emails.filter(
      (emailData) =>
        emailData.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        emailData.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [emails, searchTerm]);

  return (
    <div className="flex justify-center pt-24">
      <div className="w-full md:w-[1100px]">
        <h1 className="text-3xl mb-6">Users Who Accepted Marketing Emails:</h1>
        <div className="mb-4 relative">
          <input
            type="text"
            placeholder="Search by name or email..."
            className="w-full px-4 py-2 pl-10 bg-white/10 rounded-full text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Search className="absolute left-3 top-2.5 w-5 h-5 text-white/50" />
        </div>
        <div className="py-6 px-10 bg-white/10 rounded-3xl">
          {filteredEmails.length > 0 ? (
            filteredEmails.map((emailData, index) => (
              <p key={index} className="mb-2">
                {emailData.full_name}:{' '}
                <span className="text-white/50">{emailData.email}</span>
                {copiedEmail === emailData.email ? (
                  <Check className="ml-2 w-4 h-4 inline-block text-white" />
                ) : (
                  <Copy
                    className={`ml-2 w-4 h-4 inline-block cursor-pointer text-white/50 hover:text-white`}
                    onClick={() => copyToClipboard(emailData.email)}
                  />
                )}
              </p>
            ))
          ) : (
            <p className="text-white/50 text-center py-4">
              No users found matching your search.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
